export * from './lib/desktop-data-access-account-linking.module';

export * from "./lib/linked/linked.service";
